import { colors } from '@lmc/common/constants'
import { EmarModuleCard, FamilyPlanModuleCard, IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import type React from 'react'
import { PaywallTemplateWrapper } from '../../../../../components/generic/PaywallTemplateWrapper'

interface StateProps {
  testId?: string
}

const InitialAssessmentPaywallComponent: React.FC<StateProps> = ({
  testId
}) => {
  return (
    <PaywallTemplateWrapper
      data-testid={
        testId
          ? `${testId}-initial-assessment-paywall`
          : 'initial-assessment-paywall'
      }
      backgroundColor={colours.status.popout}
      title="Initial assessments"
      subTitle="Complete initial assessments covering choice and communication, health and medication, the activities of daily life and more."
      bodyText="Evaluate the care needs of your new clients."
      icon={IconType.CarePlansHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How do I use initial assessments?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/3376538-how-do-i-use-initial-assessments',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How do I finalise an initial assessment?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/3376601-how-do-i-finalise-an-initial-assessment',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
    />
  )
}

export const InitialAssessmentPaywall = InitialAssessmentPaywallComponent
